import { Injectable } from '@angular/core';
import { HttpServices } from './http-service.service';
import { GlobalServices } from './global.service';
import { Languages } from '../models/enums.model';

@Injectable({
  providedIn: 'root'
})
export class RequestHistoryService {

  constructor(private http: HttpServices, private global: GlobalServices) { }

  public getAdminRequestHistory (requestId: string) 
  {
    return this.http.get('Tasks/GetAdminCompletedTasks?reqId=' + requestId  
                         + '&lang=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En"));
  }

  public getUserRequestHistory (requestId: string, userName: string) 
  {
    return this.http.get('Tasks/GetUserCompletedTasks?reqId=' + requestId + '&userName=' + userName
                         + '&lang=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En"));
  }
}
